// extracted by mini-css-extract-plugin
module.exports = {"space_between_wrapper":"style_space_between_wrapper__g6q9f"};